import uniq from "lodash/uniq";

export const getOptions = (staticList, dynamicList = []) =>
  uniq([...staticList, ...dynamicList]).map(value => {
    const optionValue = Array.isArray(value) ? value[0] : value;
    const optionLabel = Array.isArray(value) ? value[1] : value;

    return {
      value: optionValue,
      label: optionLabel,
    };
  });
